<template lang="pug">

  .payment-form
    h4.section-title {{ $t('payment_form.credit_card') }}
    .form-group.same-as-checkbox.no-check(v-if="authenticated")
      .form-check
        input#sameAsAccountCheckbox(v-model="sameAsAccount", type="checkbox")
        label(for="sameAsAccountCheckbox") Same details as account
    .row
      .col-lg-6
        form-group-row(:form='form', :label="$t('payment_form.cc_first_name')", name='cc_first_name')
          form-input(:form='form', name='cc_first_name', :readonly="sameAsAccount")
      .col-lg-6
        form-group-row(:form='form', :label="$t('payment_form.cc_last_name')", name='cc_last_name')
          form-input(:form='form', name='cc_last_name', :readonly="sameAsAccount")
    .row
      .col-lg-6
        form-group-row(:form='form', :label="$t('payment_form.cc_number')", name='cc_number')
          form-input(:form='form', name='cc_number')
      .col-lg-2
        form-group-row(:form='form', :label="$t('payment_form.cc_code')", name='cc_code')
          form-input(:form='form', name='cc_code')
      .col-lg-2
        form-group-row(:form='form', :label="$t('payment_form.cc_expiration_month')", name='cc_expiration_month')
          v-select.form-control(v-model="form._cc_expiration_month", :options="monthOptions()", :searchable="false", :class="{'is-invalid': form.errors.has('cc_expiration_month')}")
      .col-lg-2
        form-group-row(:form='form', :label="$t('payment_form.cc_expiration_year')", name='cc_expiration_year')
          v-select.form-control(v-model="form._cc_expiration_year", label="value", :options="yearOptions()", :searchable="false", :class="{'is-invalid': form.errors.has('cc_expiration_year')}")
    .row(v-if="emailRequired")
      .col-lg-6
        form-group-row(:form='form', :label="$t('register.email')", name='email')
          form-input(:form='form', name='email', type='email')
    h4.section-title {{ $t('payment_form.billing_address') }}
    .row
      .col-lg-6
        form-group-row(:form='form', :label="$t('payment_form.country')", name='billing_country')
          v-select.form-control(v-model="country", label="value", :options="countries", :searchable="true", :class="{'is-invalid': form.errors.has('billing_country')}")
      .col-lg-6
        form-group-row(:form='form', :label="$t('payment_form.address')", name='billing_address')
          form-input(:form='form', name='billing_address', :readonly="sameAsAccount && userPropertyNotEmpty('address')")
    .row
      .col-lg-6
        form-group-row(:form='form', :label="$t('payment_form.city')", name='billing_city')
          form-input(:form='form', name='billing_city', :readonly="sameAsAccount && userPropertyNotEmpty('city')")
      .col-lg-4
        form-group-row(:form='form', :label="$t('payment_form.state')", name='billing_state')
          v-select.form-control(v-if="unitedStates" v-model="state", label="value", :options="states", :searchable="true", :class="{'is-invalid': form.errors.has('billing_state')}")
          form-input(v-else="" :form='form', name='billing_state', :readonly="sameAsAccount && userPropertyNotEmpty('state')")
      .col-lg-2
        form-group-row(:form='form', :label="$t('payment_form.zip')", name='billing_zip')
          form-input(:form='form', name='billing_zip', :readonly="sameAsAccount && userPropertyNotEmpty('postcode')")
    .row.justify-content-center
      .col-lg-12.text-center
        v-button.btn-primary(:loading="form.busy") {{ $t('buy_cards.submit') }}

</template>

<script>
import { mapGetters } from 'vuex';
import countries from 'country-list';
import { UsaStates } from 'usa-states';

const SAME_AS_ACCOUNT_MAPPING = {
  cc_first_name: 'first_name',
  cc_last_name: 'last_name',
  billing_address: 'address',
  billing_city: 'city',
  billing_state: 'state',
  billing_zip: 'postcode',
}

export default {
  name: 'payment-form',

  props: ['form'],

  data: () => ({
    emailRequired: false,
    countries: [],
    current_year: (new Date()).getFullYear(),
    sameAsAccount: false,
    states: null,
    state: null,
    unitedStates: null,
    country: null,
  }),

  computed: {
    ...mapGetters({
      user: 'authUser',
      authenticated: 'authCheck'
    })
  },

  watch: {
    sameAsAccount(newVal) {
      if (newVal) {
        this.copyAccount();
      }
      this.sameAsAccount = newVal;
    },
    country(val) {
      this.$set(this.form, 'billing_country', val ? val.value : null);
    },
    'form.billing_country': function(val) {
      const unitedStates = val == 'United States';
      if (this.unitedStates != unitedStates) {
        this.$set(this.form, 'billing_state', null);
        this.state = null;
        this.unitedStates = unitedStates;
      }
    },
    state(val) {
      this.$set(this.form, 'billing_state', val ? val.value : null);
    },
  },

  async created() {
    this.emailRequired = !this.authenticated && !window.addiesaas.config.registerWithPurchase;

    this.countries = await countries().getNames().map(x => ({value: x}));

    this.country = this.countries.find(x => x.value == 'United States');

    this.states = (new UsaStates()).states.map(x => ({value: x.name}));
  },

  methods: {
    monthOptions() {
      return [...Array(12).keys()].map(x => ({label: String('0' + (x + 1)).slice(-2), value: x + 1}));
    },
    yearOptions() {
      return [...Array(20).keys()].map(x => ({value: (x + this.current_year).toString()}));
    },
    copyAccount() {
      Object.keys(SAME_AS_ACCOUNT_MAPPING).forEach(k => {
        this.form[k] = this.user[SAME_AS_ACCOUNT_MAPPING[k]];
      });
    },
    userPropertyNotEmpty(prop) {
      return prop in this.user && this.user[prop] != null && this.user[prop].length > 0;
    }
  }
}
</script>

